var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30869 15.3282C2.60917 15.5149 2.96669 15.6249 3.35959 15.6249H14.2694C16.2067 15.6249 17.8842 14.2794 18.3045 12.3881C18.4554 11.7091 18.5348 11.0162 18.5417 10.3208V14.5833C18.5417 16.5393 16.956 18.1249 15 18.1249H5.41665C3.80162 18.1249 2.47273 16.8998 2.30869 15.3282Z",
    fill: "#16141C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.83362 2.70825C3.87761 2.70825 2.29195 4.29391 2.29195 6.24992V9.25535C2.29195 10.483 2.03433 11.6969 1.53575 12.8187C0.949211 14.1384 1.91523 15.6249 3.35941 15.6249H14.2692C16.2066 15.6249 17.884 14.2793 18.3043 12.3881C18.4622 11.6772 18.542 10.9511 18.542 10.2229V6.24992C18.542 4.29391 16.9563 2.70825 15.0003 2.70825H5.83362Z",
    fill: "#16141C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 1.875C7.84518 1.875 8.12501 2.15482 8.12501 2.5V4.16667C8.12501 4.51184 7.84518 4.79167 7.50001 4.79167C7.15483 4.79167 6.87501 4.51184 6.87501 4.16667V2.5C6.87501 2.15482 7.15483 1.875 7.50001 1.875Z",
    fill: "#16141C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.875C13.6785 1.875 13.9583 2.15482 13.9583 2.5V4.16667C13.9583 4.51184 13.6785 4.79167 13.3333 4.79167C12.9882 4.79167 12.7083 4.51184 12.7083 4.16667V2.5C12.7083 2.15482 12.9882 1.875 13.3333 1.875Z",
    fill: "#16141C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 7.5C6.04167 7.15482 6.32149 6.875 6.66667 6.875H6.87501C7.22018 6.875 7.50001 7.15482 7.50001 7.5C7.50001 7.84518 7.22018 8.125 6.87501 8.125H6.66667C6.32149 8.125 6.04167 7.84518 6.04167 7.5Z",
    fill: "#16141C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.2083C6.32149 10.2083 6.04167 10.4882 6.04167 10.8333C6.04167 11.1785 6.32149 11.4583 6.66667 11.4583H6.87501C7.22018 11.4583 7.50001 11.1785 7.50001 10.8333C7.50001 10.4882 7.22018 10.2083 6.87501 10.2083H6.66667Z",
    fill: "#16141C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37501 7.5C9.37501 7.15482 9.65483 6.875 10 6.875H10.2083C10.5535 6.875 10.8333 7.15482 10.8333 7.5C10.8333 7.84518 10.5535 8.125 10.2083 8.125H10C9.65483 8.125 9.37501 7.84518 9.37501 7.5Z",
    fill: "#16141C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2083C9.65483 10.2083 9.37501 10.4882 9.37501 10.8333C9.37501 11.1785 9.65483 11.4583 10 11.4583H10.2083C10.5535 11.4583 10.8333 11.1785 10.8333 10.8333C10.8333 10.4882 10.5535 10.2083 10.2083 10.2083H10Z",
    fill: "#16141C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 7.5C12.7083 7.15482 12.9882 6.875 13.3333 6.875H13.5417C13.8868 6.875 14.1667 7.15482 14.1667 7.5C14.1667 7.84518 13.8868 8.125 13.5417 8.125H13.3333C12.9882 8.125 12.7083 7.84518 12.7083 7.5Z",
    fill: "#16141C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.2083C12.9882 10.2083 12.7083 10.4882 12.7083 10.8333C12.7083 11.1785 12.9882 11.4583 13.3333 11.4583H13.5417C13.8868 11.4583 14.1667 11.1785 14.1667 10.8333C14.1667 10.4882 13.8868 10.2083 13.5417 10.2083H13.3333Z",
    fill: "#16141C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.6470fcf67719fc858937e241d879d1d9.svg";
export { ForwardRef as ReactComponent };